<template>
  <v-card>
    <v-card-text>
      <form data-vv-scope="fireAttchForm">
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex xs12 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.fireAttchRemarks }}</v-subheader>
              <div class="queryValue">{{ fireAttchForm.fireAttchRemarks }}</div>
            </v-flex>
            <v-flex xs12 v-else>
              <v-textarea
                v-model="fireAttchForm.fireAttchRemarks"
                :label="labels.fireAttchRemarks"
                :error-messages="errors.collect('fireAttchForm.fireAttchRemarks')"
                v-validate="'max:1000|entry'"
                data-vv-name="fireAttchForm.fireAttchRemarks"
                :data-vv-as="labels.fireAttchRemarks"
                :counter="1000"
                :rows="8"
              ></v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-card-text>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'

export default {
  data() {
    return {
      labels: {
        fireAttchRemarks: 'Fire Attachment'
      },
      fireAttchForm: {
        survNo: undefined,
        verCnt: undefined,
        fireAttchRemarks: undefined,
        survDetType: 'fireAttachment'
      },
      actionLabel: {
        exit: 'Exit',
        save: 'Save',
        reset: 'Reset'
      },
      loading: false,
      showErrorDialog: false,
      submitting: false
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    riskSurveyMenu() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveySettings.menu
    },
    riskSurveyMaster() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMaster
    },
    riskSurveyDetails() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyDetails
    },
    riskSurveyMode() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMode
    }
  },
  methods: {
    async doInit() {
      this.fireAttchForm.survNo = this.riskSurveyMaster.survNo
      this.fireAttchForm.verCnt = this.riskSurveyMaster.verCnt
      this.loadInit()
    },
    loadInit() {
      this.fireAttchForm.fireAttchRemarks = this.riskSurveyDetails.fireAttchRemarks
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    doReset() {
      this.fireAttchForm.fireAttchRemarks = undefined
    }
  },
  created() {},
  mounted() {
    this.doInit()
  },
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit').then(() => {
        this.$store.dispatch('riskSurveyInit').then(() => {
          this.doInit()
        })
      })
    } else {
      this.$store.dispatch('riskSurveyInit').then(() => {
        this.doInit()
      })
    }
  },
  mixins: [MessageMixin],
  components: {}
}
</script>
<style lang="scss">
@import '../../../../../assets/scss/accounting.scss';
</style>
